import React, { Component } from 'react';
import { connect } from 'react-redux';

import ScriptSegments from './ScriptSegments';
import Timer from './Timer';
import ModeratorAdvice from './ModeratorAdvice';
import { signalEndConversation } from '../actions';

const mapStateToProps = (state) => {
    return ({
        endConversation: state.convo.meta.endConversation,
        convoCode: state.convo.meta.convoCode
    });
}

class ModeratorBoard extends Component {
    constructor(props) {
        super(props);
        this.endConversation = this.endConversation.bind(this);
    }

    endConversation(event) {
        console.log("triggered end of conversation");
        this.props.dispatch(signalEndConversation(this.props.convoCode));
    }

    render() {
        return (
            <div>
                <h2>Moderator's tools</h2>
                <ModeratorAdvice />
                <ScriptSegments guests={this.props.guests} />
                <Timer />
                <button onClick={this.endConversation}>End conversation</button>
            </div>
        );
    }
}
export default connect(mapStateToProps)(ModeratorBoard);


// WEBPACK FOOTER //
// ./src/components/ModeratorBoard.js